$(document).on('submit', '[data-oci-form]', function(event) {
  event.preventDefault();
  $.ajax({
    url: $(this).attr('data-oci-clear-cart'),
    type: 'POST',
    data: {
      csrfmiddlewaretoken: $('meta[name="csrf-token"]').attr('content'),
    },
  }).then(() => {
    this.submit();
  });
});

$(document).on('click', '[data-oci-button]', () => {
  $('[data-oci-form]').trigger('submit');
});
